import { UIRepository } from "../domain/repositories/UIRepository";
import { urlResource } from './remote/urlResource';
import { axiosApp } from './remote/AxiosFactory';
import { handleRemoteResponse } from './remote/hanldeRemoteResponse';
import { handleAxiosResult } from "./remote/handleAxiosResult";

export class UIDataRepository implements UIRepository {

    async getBanner(): Promise<string[]> {
        const result = await handleAxiosResult(axiosApp(false).get(`banner/`))
        return handleRemoteResponse(result, (r: any) => {
            return r.map((path: string) => {
                return urlResource(path);
            });
        })
    }

}